'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);
var _reactScroll = require('react-scroll');

var _components = require('../../components');







var _containers = require('../../containers');

var _constants = require('../../constants');





var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _professionals = require('../../redux/modules/professionals');




var _receiveSuggestions = require('../../redux/modules/receiveSuggestions');
var _searchAddressLocus = require('../../redux/modules/searchAddressLocus');

var _ProfessionalsPage = require('./ProfessionalsPage.scss');var _ProfessionalsPage2 = _interopRequireDefault(_ProfessionalsPage);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _services = require('../../services');
var _messageModal = require('../../redux/modules/messageModal');
var _BrokerCommunityContainer = require('../../containers/BrokerCommunityContainer/BrokerCommunityContainer');




var _descriptions = require('./descriptions');
var _DescriptionTextBlock = require('../../components/DescriptionTextBlock/DescriptionTextBlock');var _DescriptionTextBlock2 = _interopRequireDefault(_DescriptionTextBlock);

var _OMDropdown = require('../../components/OMComponents/OMDropdown/OMDropdown');var _OMDropdown2 = _interopRequireDefault(_OMDropdown);
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);

var _constants2 = require('../../containers/RealtorsAssociationContainer/constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Redux
// Styles
var limit = 25;var ProfessionalsPage = function (_Component) {_inherits(ProfessionalsPage, _Component);function ProfessionalsPage(props) {_classCallCheck(this, ProfessionalsPage);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);

    var companiesTypes = (0, _constants.getProfessionalsTypes)(props.translate);

    _this.throttledCalcSwitchButtonsCount = (0, _debounce2.default)(_this.calcSwitchButtonsCount, 100);

    _this.query = {
      $skip: 0,
      $limit: limit };


    _this.state = {
      captcha: null,
      companyNameForFilter: '',
      currentCompanyType: (0, _get2.default)(props, 'location.query.type', _constants.PROFESSIONALS_TYPES.AGENCY),
      companiesTypes: companiesTypes,
      maxSwitchButtonsCount: companiesTypes.length + 1 };return _this;

  }ProfessionalsPage.prototype.

  componentWillMount = function componentWillMount() {var _props$location$query =
    this.props.location.query,professionals_city = _props$location$query.professionals_city,property_city = _props$location$query.property_city;

    var isBrokerCommunity = this.checkIsBrokerCommunity();
    var isRealtorsAssociation = this.checkIsRealtorsAssociation();

    this.query = Object.assign({},
    this.query, {
      city: professionals_city || undefined,
      property_city: property_city || undefined },
    professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {}, {
      type: this.state.currentCompanyType,
      is_community_member: isBrokerCommunity || undefined,
      is_association_member: isRealtorsAssociation || undefined });

    this.loadProfessionals(this.query);
  };ProfessionalsPage.prototype.

  componentDidMount = function componentDidMount() {
    if (!this.props.isMobile) {
      this.calcSwitchButtonsCount();
      window.addEventListener('resize', this.throttledCalcSwitchButtonsCount);
    }
  };ProfessionalsPage.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var isBrokerCommunity = this.checkIsBrokerCommunity(newProps);
    var isProfessionalsPage = this.checkIsProfessionals(newProps);
    var isRealtorsAssociation = this.checkIsRealtorsAssociation(newProps);

    var isLocaleChanged = this.props.locale !== newProps.locale;
    var isCityChanged =
    this.props.location.query.professionals_city !== newProps.location.query.professionals_city;

    var isPropertyCityChanged = this.props.location.query.property_city !== newProps.location.query.property_city;
    var isPageChanged = this.checkIsBrokerCommunity() !== isBrokerCommunity ||
    this.checkIsRealtorsAssociation() !== isRealtorsAssociation;
    var shouldLoadProfessionals = isPageChanged && (
    isBrokerCommunity || isProfessionalsPage || isRealtorsAssociation);

    if (isPageChanged) {
      this.query = Object.assign({},
      this.query, {
        $skip: 0 });

    }

    if (shouldLoadProfessionals) {
      this.props.clearProfessionals();
    }

    if (isLocaleChanged) {
      this.setState({ companiesTypes: (0, _constants.getProfessionalsTypes)(newProps.translate) });
    }

    if (isLocaleChanged && this.props.location.query.professionals_city || isCityChanged ||
    shouldLoadProfessionals || isPropertyCityChanged) {var _newProps$location$qu =
      newProps.location.query,professionals_city = _newProps$location$qu.professionals_city,property_city = _newProps$location$qu.property_city;
      var query = professionals_city ?
      { city: professionals_city } :
      { city: undefined };

      this.query = Object.assign({},
      this.query, {
        $skip: 0,
        $limit: limit },
      professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {}, {
        property_city: property_city || undefined },
      query, {
        is_community_member: isBrokerCommunity || undefined,
        is_association_member: isRealtorsAssociation || undefined,
        type: this.state.currentCompanyType });

      this.loadProfessionals(this.query);

      var searchQuery = {
        locale: newProps.locale === 'fr' ? 'en' : newProps.locale, // TODO change this when locus supports French address
        type: 'city',
        tags: [newProps.location.query.professionals_city] };

      this.props.searchAddress(searchQuery);
    }
  };ProfessionalsPage.prototype.

  componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var nameWasChanged = prevState.companyNameForFilter !== this.state.companyNameForFilter;

    if (nameWasChanged && (!this.state.companyNameForFilter.length || this.state.companyNameForFilter.length > 2)) {var _props$location$query2 =
      this.props.location.query,property_city = _props$location$query2.property_city,professionals_city = _props$location$query2.professionals_city;
      var isBrokerCommunity = this.checkIsBrokerCommunity();
      var isRealtorsAssociation = this.checkIsRealtorsAssociation();

      this.query = Object.assign({},
      this.query, {
        property_city: property_city || undefined,
        city: professionals_city || undefined,
        name: this.state.companyNameForFilter || undefined,
        is_community_member: isBrokerCommunity || undefined,
        is_association_member: isRealtorsAssociation || undefined,
        $skip: 0,
        type: this.state.currentCompanyType },
      professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {});


      this.loadProfessionals(this.query);
    }
  };ProfessionalsPage.prototype.

  componentWillUnmount = function componentWillUnmount() {
    if (!this.props.isMobile) {
      window.removeEventListener('resize', this.throttledCalcSwitchButtonsCount);
    }
  };ProfessionalsPage.prototype.

















































































































































































































































































































  render = function render() {var _cx, _cx2, _cx3;
    var searchInputPlaceholder = this.props.translate('professionals', 'searchInputPlaceholder');
    var isSearchedProfessionals = !!this.props.location.query.professionals_city;
    var isSearchedProperty = !!this.props.location.query.property_city;
    var professionalsNotFound = (isSearchedProfessionals || isSearchedProperty) &&
    this.props.professionals && !this.props.professionals.length;
    var isRealtorsAssociation = this.checkIsRealtorsAssociation();
    var isBroker = this.checkIsBrokerCommunity();

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProfessionalsPage2.default.professionalsPage, (_cx = {}, _cx[_ProfessionalsPage2.default.brokerPage] = isBroker || isRealtorsAssociation, _cx)) },
        _react2.default.createElement(_components.NotificationNoCompany, null),
        this.renderHelmet(),
        isBroker &&
        _react2.default.createElement(_components.CompanyInfoBlock, {
          translate: this.props.translate('companyPage'),
          title: _BrokerCommunityContainer.BROKER_COMPANY_NAME,
          phoneNumber: _BrokerCommunityContainer.BROKER_COMPANY_PHONE,
          isMobile: this.props.isMobile,
          locale: this.props.locale,
          scrollToBlock: 'professionals-page-content',
          offset: 474,
          isShowMoreInfo: true }),

        _react2.default.createElement(_reactScroll.Element, { name: 'professionals-page-content' },
          isBroker && !isRealtorsAssociation && _react2.default.createElement(_containers.BrokerCommunityContainer, null),
          isRealtorsAssociation && _react2.default.createElement(_containers.RealtorsAssociationContainer, null),
          _react2.default.createElement('div', { className: _ProfessionalsPage2.default.contentPart },
            _react2.default.createElement('div', {
                className:
                (0, _classnames2.default)(
                _ProfessionalsPage2.default.pageHeaderWrapper, (_cx2 = {}, _cx2[

                _ProfessionalsPage2.default.brokerHeader] = isBroker || isRealtorsAssociation, _cx2[
                this.classNameHeader()] = !this.props.isMobile, _cx2)) },




              _react2.default.createElement('div', { className: _ProfessionalsPage2.default.pageHeader },
                _react2.default.createElement('div', { className: _ProfessionalsPage2.default.titleWrapper },
                  this.checkIsProfessionals() && this.renderH2(),
                  !this.props.isMobile && !isBroker && !isRealtorsAssociation && this.renderGetHereButton()),


                _react2.default.createElement('div', { className: (0, _classnames2.default)(
                    _ProfessionalsPage2.default.searchWrapper, (_cx3 = {}, _cx3[_ProfessionalsPage2.default.searchBrokerWrapper] = isBroker || isRealtorsAssociation, _cx3)) },


                  _react2.default.createElement('div', { className: _ProfessionalsPage2.default.searchInput },
                    _react2.default.createElement('div', { className: _ProfessionalsPage2.default.searchInputLabel }, this.props.translate('professionals', 'searchInputLabel')),
                    _react2.default.createElement(_components.ProfessionalsPageSearchInput, {
                      suggestions: this.props.suggestions,
                      className: _ProfessionalsPage2.default.inputWrapper,
                      city: this.props.location.query.professionals_city,
                      translate: this.props.translate,
                      locale: this.props.locale,
                      receiveSuggestions: this.props.receiveSuggestions,
                      placeholder: searchInputPlaceholder,
                      address: this.props.address,
                      searchAddress: this.props.searchAddress,
                      isBrokerCommunity: isBroker,
                      isRealtorsAssociation: isRealtorsAssociation,
                      query: this.props.location.query,
                      queryName: 'professionals_city' })),


                  _react2.default.createElement('div', { className: _ProfessionalsPage2.default.searchInput },
                    _react2.default.createElement('div', { className: _ProfessionalsPage2.default.searchInputLabel }, this.props.translate('professionals', 'propertyIn')),
                    _react2.default.createElement(_components.ProfessionalsPageSearchInput, {
                      suggestions: this.props.suggestions,
                      className: _ProfessionalsPage2.default.inputWrapper,
                      city: this.props.location.query.property_city,
                      translate: this.props.translate,
                      locale: this.props.locale,
                      receiveSuggestions: this.props.receiveSuggestions,
                      placeholder: searchInputPlaceholder,
                      address: this.props.address,
                      searchAddress: this.props.searchAddress,
                      isBrokerCommunity: isBroker,
                      isRealtorsAssociation: isRealtorsAssociation,
                      query: this.props.location.query,
                      queryName: 'property_city' })),


                  this.renderNameInput(),
                  !isBroker && !isRealtorsAssociation && this.props.isMobile && this.renderMobileSwitcher()),

                this.props.isMobile && !isBroker && !isRealtorsAssociation && this.renderGetHereButton())),


            !this.props.isMobile && this.renderSwitcher(),

            !isBroker && !isRealtorsAssociation && this.renderProfessionalsDescription(),

            _react2.default.createElement(_components.ProfessionalsList, {
              isMobile: this.props.isMobile,
              professionals: this.props.professionals,
              translate: this.props.translate,
              locale: this.props.locale,
              isProfessionals: this.checkIsProfessionals(),
              isBroker: isBroker || isRealtorsAssociation,
              companyNameForFilter: this.state.companyNameForFilter,
              loadMore: this.loadMoreProfessionals,
              hasMore: this.props.professionalsCount > this.props.professionals.length,
              currentCompanyType: this.state.currentCompanyType,
              isMobal: true }),


            professionalsNotFound && this.renderProfessionalsNotFound()),

          !isBroker && !isRealtorsAssociation && this.renderProfessionalContactUs(),

          !isBroker && !isRealtorsAssociation &&
          _react2.default.createElement('div', { className: _ProfessionalsPage2.default.bottomText },
            this.renderProfessionalsDescription('all'))),



        _react2.default.createElement(_components.Modal, {
            className: 'contactProfessionalsModal',
            isOpen: this.props.professionalContactFormIsOpen,
            onRequestClose: this.closeFormModal,
            translate: this.props.translate,
            isRtl: this.props.isRtl,
            withoutTitle: true },

          _react2.default.createElement(_components.ProfessionalContactUs, {
            fetchReCaptchaToken: this.fetchReCaptchaToken,
            locale: this.props.locale,
            translate: this.props.translate,
            onSubmit: this.formSubmitHandler,
            isRtl: this.props.isRtl,
            formSubmitting: this.props.formSubmitting,
            formSubmitted: this.props.formSubmitted,
            formError: this.props.formError,
            showMessage: this.props.openMessageModal,
            isMobile: this.props.isMobile,
            closeModal: this.closeFormModal,
            className: 'professionalsPageModal',
            captchaIdentifier: 'professionalsPageModal',
            isModal: true }))));




  };return ProfessionalsPage;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.checkIsBrokerCommunity = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return (0, _get2.default)(props, 'location.pathname', '').includes('broker');};this.checkIsRealtorsAssociation = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return (0, _get2.default)(props, 'location.pathname', '').includes('realtors_association');};this.checkIsProfessionals = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;return (0, _get2.default)(props, 'location.pathname', '').includes('professionals') && !_this2.checkIsBrokerCommunity(props) && !_this2.checkIsRealtorsAssociation(props);};this.formSubmitHandler = function (formValues) {var captcha = _this2.state.captcha;_this2.props.sendProfessionalsContactUsForm(Object.assign({ captcha: captcha }, formValues));};this.openFormModal = function () {return _this2.props.openProfessionalsContactModal();};this.closeFormModal = function () {document.body.style.overflow = '';_this2.props.closeProfessionalsContactModal();};this.handleChangeName = function (evt) {var _evt$target$value = evt.target.value,value = _evt$target$value === undefined ? '' : _evt$target$value;_this2.setState({ companyNameForFilter: value });};this.handleSwitchType = function (evt) {var _props$location$query3 = _this2.props.location.query,professionals_city = _props$location$query3.professionals_city,property_city = _props$location$query3.property_city;var type = typeof evt === 'string' ? evt : evt.target.value;var query = { professionals_city: professionals_city, property_city: property_city, type: type };_this2.setState({ currentCompanyType: type });_reactRouter.browserHistory.push({ pathname: (0, _appendLocale2.default)(_this2.props.locale, '/professionals/search'), query: query });_this2.query = Object.assign({}, _this2.query, { city: professionals_city || undefined, property_city: property_city || undefined, name: _this2.state.companyNameForFilter || undefined, $skip: 0 }, professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {}, { type: type });_this2.loadProfessionals(_this2.query);};this.loadMoreProfessionals = function () {if (!_this2.props.professionalsLoaded || _this2.props.professionalsLoading) {return;}var _props$location$query4 = _this2.props.location.query,professionals_city = _props$location$query4.professionals_city,property_city = _props$location$query4.property_city;_this2.query = Object.assign({}, _this2.query, { city: professionals_city || undefined, property_city: property_city || undefined, $skip: _this2.query.$skip + limit }, professionals_city || property_city ? { $skip: undefined, $limit: undefined } : {});_this2.loadProfessionals(_this2.query);};this.loadProfessionals = function (query) {_this2.props.receiveProfessionals(query);};this.fetchReCaptchaToken = function (token) {return _this2.setState({ captcha: token });};this.calcSwitchButtonsCount = function () {if (!_this2.switcher) {return;}var _ref = _this2.switcher || {},clientWidth = _ref.clientWidth,_ref$children = _ref.children,children = _ref$children === undefined ? [] : _ref$children;var width = 0;var count = 0; // for (let idx = 0; idx < this.state.companiesTypes.length + 1; idx += 1) {
    for (var idx = 0; idx < _this2.state.companiesTypes.length; idx += 1) {var currentEl = children[idx];width += currentEl.clientWidth + 20;if (width > clientWidth - 110) {break;}if (!currentEl || !currentEl.value) {count += 1;break;}count += 1;}_this2.setState({ maxSwitchButtonsCount: count });};this.classNameHeader = function () {switch (_this2.props.routetype) {case 'moving':return _ProfessionalsPage2.default.moving;case 'mortgage':return _ProfessionalsPage2.default.mortgage;case 'designer':return _ProfessionalsPage2.default.designer;case 'lawyer':return _ProfessionalsPage2.default.lawyer;case 'photographer':return _ProfessionalsPage2.default.photographer;case 'appraisal':return _ProfessionalsPage2.default.appraisal;default:return _ProfessionalsPage2.default.realEstateAgency;}};this.renderHelmet = function () {var route = _this2.props.route;var isRealtorsAssociation = _this2.checkIsRealtorsAssociation();var isProfessionals = _this2.checkIsProfessionals();var contentImage = isRealtorsAssociation ? _constants2.REALTORS_ASSOCIATION_LOGO : _BrokerCommunityContainer.BROKER_COMPANY_LOGO;var params = [{ property: 'og:image', content: contentImage }, { property: 'og:image:width', content: 250 }, { property: 'og:image:height', content: 250 }, { name: 'image', itemProp: 'image', content: contentImage }];return _react2.default.createElement(_reactHelmet2.default, { titleTemplate: _this2.props.translate('title', 'titleTemplate')(), title: _this2.props.translate('helmet', _this2.checkIsBrokerCommunity() ? 'brokerCommunity' : 'professionals')(), meta: [{ property: 'og:url', content: '' + _constants.shareUrl + route }, { property: 'og:title', content: _this2.props.translate('helmet', 'professionals') + ' | \u202BOnMap' }].concat(!isProfessionals ? params : [], _this2.props.locale !== _constants.language.default ? [{ name: 'robots', content: 'noindex,nofollow' }] : []) });};this.renderProfessionalsNotFound = function () {var handleClick = function handleClick() {if (_this2.checkIsBrokerCommunity()) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(_this2.props.locale, '/professionals/broker'));} else if (_this2.checkIsRealtorsAssociation()) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(_this2.props.locale, 'realtors_association'));} else {_reactRouter.browserHistory.push((0, _appendLocale2.default)(_this2.props.locale, '/professionals'));}};return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.notFoundWrapper }, _react2.default.createElement('div', { className: _ProfessionalsPage2.default.notFoundTitle }, _this2.props.translate('professionals', 'notFoundTitle')), _react2.default.createElement('div', { className: _ProfessionalsPage2.default.notFoundDescription }, _this2.props.translate('professionals', 'notFoundDescription')), _react2.default.createElement('div', { className: _ProfessionalsPage2.default.showAllWrapper }, _react2.default.createElement('span', null, _this2.props.translate('professionals', 'or')), _react2.default.createElement('button', { className: _ProfessionalsPage2.default.showAllProfessionals, onClick: handleClick }, _this2.props.translate('professionals', 'showAllProfessionals'))));};this.renderH2 = function () {var Tag = _this2.checkIsBrokerCommunity() ? 'h1' : 'h2';return _react2.default.createElement(Tag, { className: _ProfessionalsPage2.default.pageTitle }, _this2.props.translate('title', _this2.checkIsBrokerCommunity() ? 'brokerCommunity' : 'professionals'));};this.renderNameInput = function () {return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.nameInputWrapper }, _react2.default.createElement('div', { className: _ProfessionalsPage2.default.searchInputLabel }, _this2.props.translate('professionals', 'filterByName')), _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: _this2.props.translate('realEstateDetails', 'companyName'), value: _this2.state.companyNameForFilter, onChange: _this2.handleChangeName }));};this.renderSwitchButton = function (button) {var _cx4;return _react2.default.createElement('button', { key: button.type, onClick: _this2.handleSwitchType, value: button.type, className: (0, _classnames2.default)((_cx4 = {}, _cx4[_ProfessionalsPage2.default.active] = _this2.state.currentCompanyType === button.type, _cx4)) }, button.title);};this.renderGetHereButton = function () {return _react2.default.createElement('button', { className: _ProfessionalsPage2.default.getHereButton, onClick: _this2.openFormModal }, _this2.props.translate('professionals', 'joinUs'));};this.renderMobileSwitcher = function () {var options = [].concat(_this2.state.companiesTypes).map(function (it) {return { id: it.type, label: it.title };});var selected = options.find(function (_ref2) {var id = _ref2.id;return id === _this2.state.currentCompanyType;});return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.dropdownWrapper }, _react2.default.createElement(_OMDropdown2.default, { options: options, selectedOption: selected, handleSelect: _this2.handleSwitchType, callToAction: _this2.props.translate('professionals', 'selectCategory').toString() }));};this.renderSwitcher = function () {if (!_this2.checkIsProfessionals()) {return null;}var switchButtons = [].concat(_this2.state.companiesTypes);var mainButtons = switchButtons.splice(0, _this2.state.maxSwitchButtonsCount);var additionalOptions = switchButtons.map(function (it) {return { id: it.type, label: it.title };});var selected = additionalOptions.find(function (_ref3) {var id = _ref3.id;return id === _this2.state.currentCompanyType;});return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.switchTypes, ref: function ref(_ref4) {_this2.switcher = _ref4;} }, mainButtons.map(_this2.renderSwitchButton), !!additionalOptions.length && _react2.default.createElement(_OMDropdown2.default, { options: additionalOptions, selectedOption: selected, handleSelect: _this2.handleSwitchType, callToAction: _this2.props.translate('header', 'more').toString(), isTab: true }));};this.renderProfessionalContactUs = function () {return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.contactUsWrapper }, _react2.default.createElement(_components.ProfessionalContactUs, { fetchReCaptchaToken: _this2.fetchReCaptchaToken, locale: _this2.props.locale, translate: _this2.props.translate, onSubmit: _this2.formSubmitHandler, isRtl: _this2.props.isRtl, formSubmitting: _this2.props.formSubmitting, formSubmitted: _this2.props.formSubmitted, formError: _this2.props.formError, showMessage: _this2.props.openMessageModal, closeModal: _this2.closeFormModal, isMobile: _this2.props.isMobile, className: 'professionalsPage', captchaIdentifier: 'professionalsPage' }));};this.renderProfessionalsDescription = function () {var currentCompanyType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.currentCompanyType;var description = (0, _descriptions.getProfessionalDescription)(currentCompanyType, _this2.props.locale);var title = currentCompanyType === 'all' ? _this2.props.translate('title', 'professionals') : _this2.props.translate('professionalsTypes', currentCompanyType);var TitleTag = currentCompanyType === 'all' ? 'div' : 'h1';return _react2.default.createElement('div', { className: _ProfessionalsPage2.default.flexContainerWrapper }, _react2.default.createElement('div', { className: _ProfessionalsPage2.default.flexContainer }, _react2.default.createElement(_DescriptionTextBlock2.default, { className: 'professionalDescription additionalBlock', locale: _this2.props.locale, contentText: description.col1 + '\n\n' + description.col2, translate: _this2.props.translate, title: title.toString(), titleTag: TitleTag, isTitleTranslated: true })));};};

ProfessionalsPage.propTypes = {
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  professionals: _propTypes2.default.array,
  professionalsCount: _propTypes2.default.number,
  suggestions: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  route: _propTypes2.default.any,
  receiveProfessionals: _propTypes2.default.func,
  receiveSuggestions: _propTypes2.default.func,
  location: _propTypes2.default.object,
  address: _propTypes2.default.array,
  searchAddress: _propTypes2.default.func,
  clearProfessionals: _propTypes2.default.func,
  openProfessionalsContactModal: _propTypes2.default.func,
  closeProfessionalsContactModal: _propTypes2.default.func,
  sendProfessionalsContactUsForm: _propTypes2.default.func,
  formSubmitted: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  formError: _propTypes2.default.object,
  professionalContactFormIsOpen: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  professionalsLoading: _propTypes2.default.bool,
  professionalsLoaded: _propTypes2.default.bool,
  routetype: _propTypes2.default.string };


var mapStateToProps = function mapStateToProps(state) {return {
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    professionals: state.professionals.professionals,
    professionalsLoading: state.professionals.loading,
    professionalsLoaded: state.professionals.loaded,
    professionalsCount: state.professionals.professionalsCount,
    suggestions: state.suggestions.suggestions,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    address: state.searchAddressLocus.address,
    formSubmitted: state.professionals.formSubmitted,
    formSubmitting: state.professionals.formSubmitting,
    formError: state.professionals.formError,
    professionalContactFormIsOpen: state.professionals.professionalContactFormIsOpen,
    routetype: state.routing.locationBeforeTransitions.query.type };};


var mapDispatchToProps = {
  receiveProfessionals: _professionals.receiveProfessionals,
  clearProfessionals: _professionals.clearProfessionals,
  receiveSuggestions: _receiveSuggestions.receiveSuggestions,
  searchAddress: _searchAddressLocus.searchAddress,
  openProfessionalsContactModal: _professionals.openProfessionalsContactModal,
  closeProfessionalsContactModal: _professionals.closeProfessionalsContactModal,
  sendProfessionalsContactUsForm: _professionals.sendProfessionalsContactUsForm,
  openMessageModal: _messageModal.openMessageModal };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
ProfessionalsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ProfessionalsPage/ProfessionalsPage.js
// module id = 3097
// module chunks = 0